import { constTrue, flow, pipe } from 'fp-ts/function';
import * as option from 'fp-ts/Option';
import * as alternative from './alternative.js';
import * as apply from './apply.js';
import * as chain from './chain.js';
export * from 'fp-ts/Option';
export const map2 = apply.map2(option.Apply);
export const sequenceS = apply.sequenceS(option.Apply);
export const sequenceT = apply.sequenceT(option.Apply);
export const bindSequenceS = chain.bindSequenceS(option.Chain);
export const bindS = chain.bindS(option.Chain);
export const chainSequenceS = chain.chainSequenceS(option.Chain);
export const when = (condition, a) => condition ? option.of(a()) : option.none;
/**
 * Returns true if the provided predicate holds true for the element in the option, or if the option
 * is empty.
 */
export const every = (p) => option.fold(constTrue, p);
/**
 * Create an optional value depending on whether a condition is fulfilled.
 */
export const fromBoolean = (onTrue) => (condition) => condition ? option.some(onTrue()) : option.none;
/**
 * Takes a list of functions (a: A) => Option<B> and returns a function (a: A) => Option<B>, which
 * tries the given functions in order, returning the result of the first one to return Some, or None
 * if all return None.
 *
 * @example
 * assert.deepEqual(
 *   option.some(5),
 *   pipe(
 *     [1, 3, 5, 7, 9],
 *     option.altAllBy(
 *       array.findFirst((x) => x % 2 === 0),
 *       array.findFirst((x) => x >= 10),
 *       array.findFirst((x) => x >= 4),
 *     ),
 *   ),
 * );
 */
export const altAllBy = alternative.altAllBy(option.Alternative);
export const getOrThrow = (error) => (o) => pipe(o, option.getOrElse(() => {
    throw error();
}));
export function flatTraverse(F) {
    return (f) => flow(option.traverse(F)(f), (fa) => F.map(fa, option.flatten));
}
/**
 * Recover from the error using an effect.
 */
export const altM = (F) => (onNone) => (o) => option.isNone(o) ? onNone() : F.of(o);
export const match2 = (a, b, { both, fst, snd, neither, }) => option.isSome(a) && option.isSome(b)
    ? both(a.value, b.value)
    : option.isSome(a)
        ? fst(a.value)
        : option.isSome(b)
            ? snd(b.value)
            : neither();
export const chainFirstVoid = (f) => option.map((a) => (f(a), a));
//# sourceMappingURL=option.js.map